import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function LightBulbAndGearsIllustration() {
  return _jsxs("svg", {
    width: "160",
    height: "154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [_jsx("path", {
      d: "M88.63 132.814c-49.227 8.333-93.236-54.487-66.597-93.508C48.949-.12 134.534 10.126 146.832 53.886c9.926 35.316-18.06 72.133-58.202 78.928Z",
      fill: "#E6EFFF"
    }), _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M83.823 106.651c-1.188-4.177-3.286-8.024-6.009-11.408-6.759-8.4-19.442-25.332-20.963-35.841C53.61 37.01 69.135 16.23 91.527 12.989 113.92 9.75 134.7 25.273 137.94 47.666c1.465 10.122-5.27 29.757-8.943 39.455-1.437 3.791-2.226 7.796-2.174 11.85l.167 13.084-39.985 5.787-3.182-11.191Z",
      fill: "#FFD680"
    }), _jsx("circle", {
      cx: "25.711",
      cy: "25.711",
      r: "25.711",
      transform: "scale(-1 1) rotate(8.235 -279.887 -821.63)",
      fill: "#FFEBBF"
    }), _jsx("path", {
      d: "m112.206 110.767-2.98-45.814c-.176-2.705 2.443-4.729 5.016-3.876l.337.111c2.034.674 2.697 3.221 1.25 4.802l-.586.64c-4.993 5.454-13.6 5.412-18.54-.089-1.633-1.817-.58-4.721 1.837-5.071l1.056-.153c2.31-.334 4.077 2.017 3.113 4.143-3.14 6.929-11.826 9.266-18.02 4.85l-.706-.504c-1.951-1.391-1.413-4.423.897-5.058l.858-.235a3.92 3.92 0 0 1 4.847 2.855l10.907 44.949",
      stroke: "#F14F5F",
      strokeWidth: "2.624"
    }), _jsx("ellipse", {
      cx: "16.952",
      cy: "14.127",
      rx: "16.952",
      ry: "14.127",
      transform: "scale(-1 1) rotate(8.235 -794.685 -794.959)",
      fill: "#1E6DEB"
    }), _jsx("rect", {
      width: "46.617",
      height: "19.777",
      rx: "1.312",
      transform: "scale(-1 1) rotate(8.235 -761.718 -841.895)",
      fill: "#1E6DEB"
    }), _jsx("path", {
      stroke: "#70A7FF",
      strokeWidth: "2.624",
      strokeLinecap: "round",
      d: "m130.719 110.863-46.956 6.796"
    }), _jsx("rect", {
      width: "33.904",
      height: "4.238",
      rx: "1.312",
      transform: "scale(-1 1) rotate(8.235 -902.612 -802.73)",
      fill: "#00307A"
    }), _jsx("path", {
      d: "M97.258 20.953a26.386 26.386 0 0 1 6.483-.138m7.363 1.858c6.315 2.604 11.557 7.595 14.492 14.032",
      stroke: "#fff",
      strokeWidth: "2.624",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M45.614 91.766c1.734-3.38 6.82-2.31 7.044 1.483.158 2.681 3.013 4.322 5.41 3.108 3.389-1.715 6.874 2.14 4.827 5.34-1.448 2.263-.103 5.268 2.548 5.695 3.75.604 4.304 5.772.767 7.157-2.501.979-3.18 4.201-1.285 6.105 2.679 2.694.089 7.2-3.587 6.241-2.599-.678-5.041 1.53-4.628 4.184.584 3.754-4.16 5.877-6.57 2.941-1.704-2.076-4.978-1.725-6.204.665-1.733 3.38-6.82 2.309-7.044-1.483-.158-2.681-3.012-4.322-5.409-3.109-3.39 1.716-6.875-2.14-4.827-5.34 1.448-2.262.103-5.267-2.549-5.694-3.75-.604-4.304-5.773-.767-7.158 2.502-.979 3.18-4.201 1.285-6.105-2.678-2.693-.088-7.2 3.587-6.24 2.6.677 5.042-1.53 4.628-4.185-.584-3.753 4.16-5.877 6.57-2.94 1.705 2.076 4.978 1.725 6.204-.665Zm-2.965 31.546c-5.57-1.173-9.136-6.639-7.963-12.21 1.172-5.571 6.639-9.136 12.21-7.964 5.57 1.173 9.136 6.639 7.963 12.21-1.172 5.571-6.639 9.136-12.21 7.964ZM30.13 57.693c1.187-3.565 6.174-3.716 7.575-.229a4.037 4.037 0 0 0 5.136 2.285c3.528-1.295 6.756 2.51 4.903 5.78a4.036 4.036 0 0 0 1.416 5.44c3.211 1.951 2.249 6.847-1.463 7.437a4.037 4.037 0 0 0-3.37 4.499c.477 3.727-3.951 6.027-6.726 3.493a4.036 4.036 0 0 0-5.62.17c-2.616 2.697-7.175.669-6.924-3.08a4.036 4.036 0 0 0-3.636-4.288c-3.74-.364-4.997-5.193-1.909-7.334a4.036 4.036 0 0 0 1.085-5.516c-2.047-3.152.944-7.145 4.544-6.066 2.09.627 4.3-.52 4.989-2.59Zm4.456 22.046a7.823 7.823 0 1 1-.472-15.64 7.823 7.823 0 0 1 .472 15.64Z",
      fill: "#1E6DEB"
    })]
  });
}